import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "../../shared/shared.module";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";
import { LandingpageComponent } from "./landingpage.component";
import { CreateUploadFlashcardsModule } from "../create/create-upload-flashcards/create-upload-flashcards.module";
import { RegisterCtaDialogComponent } from "./register-cta-dialog/register-cta-dialog.component";

@NgModule({
  declarations: [
    LandingpageComponent,
    RegisterCtaDialogComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    LearnsetsListComponent,
    CreateUploadFlashcardsModule
],
  exports: [
    LandingpageComponent,
    RegisterCtaDialogComponent
  ]
})
export class LandingpageModule { }